module Client.Components.Shipments

open Client
open Shared
open global.Elmish
open Fable.Core
open Fable.Core.JsInterop
open Feliz
open Feliz.MaterialUI
open Thoth.Fetch
open Fable.Core.JS
open Feliz.SweetAlert
open Feliz.UseElmish
open Feliz.UseDeferred
open Fetch

let viewDetail = React.functionComponent (fun (inputProps: {| token : string; shipmentInfo : Shared.SalesOrderShipmentInfo; |}) ->
  let classes = Styles.useStyles()
  let buttonProgressIndicator =
    Mui.circularProgress [
      prop.className classes.buttonProgress
      prop.size 24
    ]
  Mui.listItem [
    listItem.alignItems.flexStart
    listItem.children [
      Mui.listItemText [
        listItemText.primary (inputProps.shipmentInfo.ShipmentDate.ToString("MM/dd/yyyy"))
        listItemText.secondary [
          Html.br []

          match inputProps.shipmentInfo.TrackingNumbers.Length with
          | 0 ->
            Mui.typography [
              typography.display.inline'
              typography.children ("Tracking information is not available for this shipment")
            ]
          | x ->
            Mui.typography [
              typography.display.inline'
              typography.children (if x > 1 then "Tracking Numbers: " else "Tracking Number: ")
            ]
            Mui.typography [
              typography.display.inline'
              typography.variant.body2
              typography.children (inputProps.shipmentInfo.TrackingNumbers |> String.concat ", ")
            ]
        ]
      ]
    ]
  ]
)

let view = React.functionComponent (fun (inputProps: {| token : string; orderId : int; |}) ->
  let entries, setEntries = React.useState(Deferred.HasNotStartedYet)
  let fetchShipments () =
    promise {
      let lookupRequest = { Shared.SupplyShipmentLookupRequest.OrderId = inputProps.orderId; }
      let url = "/api/Shipments/Lookup"
      let decoder = Services.decoder<Shared.SalesOrderShipmentInfo list>
      let extra = Services.myExtraCoders
      let authHeader = HttpRequestHeaders.Authorization <| sprintf "Bearer %s" inputProps.token
      let! fetchResult =
        Fetch.post<_,Shared.SalesOrderShipmentInfo list>(url, lookupRequest, decoder = decoder, extra = extra, headers = [ authHeader ] )
      return fetchResult
    }
  let loadData =
    async {
      let p = fetchShipments ()
      let! r = p |> Async.AwaitPromise
      let result = r
      return result
    }

  let startLoadingData =
    React.useDeferredCallback(
      (fun () ->
        loadData
      )
      , (fun x -> setEntries x)
    )
  // The second parameter of useEffect helps the component know when to re-run the effect
  React.useEffect(startLoadingData, [| |])
  Mui.grid [
    grid.container true
    grid.direction.column
    grid.spacing._2
    grid.children [
      match entries with
      | Deferred.HasNotStartedYet
      | Deferred.InProgress ->
        Mui.grid [
          grid.item true
          grid.children [
            Mui.typography [
              typography.display.inline'
              typography.variant.body2
              typography.children "Retrieving for shipment information."
            ]
            Mui.circularProgress [ ]
          ]
        ]
      | Deferred.Failed error ->
        Mui.grid [
          grid.item true
          grid.children [
            Mui.typography [
              typography.variant.h6
              typography.children "Unable to load shipment information."
            ]
          ]
        ]
      | Deferred.Resolved (entries : Shared.SalesOrderShipmentInfo list) ->
        Mui.grid [
          grid.item true
          grid.children [
            if entries.Length = 0
            then
              Mui.typography [
                typography.variant.body2
                typography.children "No tracking numbers available."
              ]
            else
              Mui.list [
                prop.width 100
                list.children [
                  yield! entries
                  |> List.mapi (fun i shipmentInfo ->                    [
                        viewDetail {| token = inputProps.token; shipmentInfo = shipmentInfo; |}
                        if entries.Length > 1 && (i+1) < entries.Length then
                          Mui.divider []
                    ]
                  )
                  |> List.concat
                ]
              ]
          ]
        ]
    ]
  ]
)